<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.relatives', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.relatives', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                ></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(student, index) in students" :key="student.id">
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="relative in student.directRelatives"
                                    :key="relative.id"
                                >
                                    <td
                                        class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                    >
                                        <InertiaLink :href="student.links.show" class="text-indigo-500">
                                            {{ student.full_name }}
                                        </InertiaLink>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        <InertiaLink :href="relative.links.show" class="text-indigo-500">
                                            {{ relative.full_name }}
                                        </InertiaLink>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ relative.last_access_text }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'students'],
};
</script>
